<template>
  <div>
    <van-uploader style="margin:20px auto;"  :after-read="uploadFile">
        <van-button icon="plus" type="primary" native-type="button">附件上传</van-button>
      </van-uploader>
  </div>
</template>

<script>

export default {
  name: 'Cost',
  props: {
    // costs:Object,
    flow_id:Number,
    // costs:Array,

  },
  data(){
    return{
      // amount:'',
      amount_word:'',
      notices:{},
      child_fileList:[],
      child_files:[],
      add_file_form:{
        flow_id:this.flow_id,
        file:''
      }

    }
  },
  created(){

  },
  methods:{
    uploadFile(file){
      // console.log(file)
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
　　  formData.append('file', file.file); //接口需要传的参数
      console.log(formData.get("file"))
      this.$http.post('/upload',formData)
      .then((res)=>{
        if(res.data.code != 200){
          this.$dialog.alert({
          message: res.data.msg,
          })
          return false;
        }
        
        // this.child_files.push(res.data.data.path)
        this.add_file_form.file = res.data.data.path
        this.addFiles();
        // this.$emit('changeFile',this.child_files)
        // console.log(this.child_files)
      })

    },
    addFiles(){
      
      this.$http.post('flow/add_files',this.add_file_form)
      .then((res)=>{
        if(res.data.code != 200){
          this.$dialog.alert({
          message: res.data.msg,
          })
          return false;
        }
        this.$toast.success('上传成功')
        this.$emit('add_success')
      })

    }
    
  },
  computed:{

  },
  watch:{
    'flow_id':function(value){
      this.add_file_form.flow_id = value
    },
    // 'amount':function(val){
      
    //   this.$emit('changePayInfo',this.payInfo)
    // },
  },
  // computed:{
  //   'costs[i].budget_usable':function(){
  //     return costs[i].budget - costs[i].budget_used;
  //   }

  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.account_top{
  border-left: #42b983 5px solid;
  height:45px;
  border-bottom:#eee 1px solid;
}
.account_top .no{
  margin:10px 5px;
  font-weight: bold;
  color:#42b983;
  float:left;
  padding-top:5px;

}
.account_top button{
  margin:10px 5px;
  color:#42b983;
  font-weight: bold;

}
h3 {
  font-size:12px;
  margin:5px;
}
p{
  margin:0px;
  font-size:12px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell-group__title{
  background-color:#3f51b5 ;
  font-size:14px;
  font-weight:blod;
  color:white;
  padding:13px;

}
.van-notice-bar{
  text-align: left;
}
</style>
